function allowPacerAdvisors(user) {
  // Allow domain with *@pacerfinancial.com
  const allowedPacerDomain = /^\S+@pacerfinancial.com$/;
  return allowedPacerDomain.test(user.email)
}

export const OnboardingBypasser = {
  allowPacerAdvisors
}


// WEBPACK FOOTER //
// ./src/utilities/onboardingBypass.js